import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Link as ScrollLink } from 'react-scroll'
import { t } from 'shared'
import styles from './read_more.module.css'
export const ReadMore: React.FC<{
  scrollToId?: string
  lineHeight: number
  lines: number
  fade?: boolean
}> = ({ scrollToId = '#', lineHeight, lines, children, fade }) => {
  const [overflowing, setOverflowing] = useState<boolean | null>(null)
  const [isExpanded, setIsExpanded] = useState(false)
  const wrapperRef = useRef<null | HTMLDivElement>(null)
  const toggleExpanded = useCallback(() => setIsExpanded((prevState) => !prevState), [])

  // Initial run, will change state `null` to `boolean`.
  useEffect(() => {
    if (!wrapperRef.current) return
    setOverflowing(
      wrapperRef.current.scrollHeight > wrapperRef.current.clientHeight ||
        wrapperRef.current.scrollWidth > wrapperRef.current.clientWidth
    )
  }, [])

  // To decide if truncation will be needed one must apply it first.
  // If it isn't needed, we can remove it and return "inherit".
  // If it is needed we keep the calculated height.
  // If if is needed and expanded state, return "inherit"
  const height = useMemo(() => {
    const calculated = `${lineHeight * lines}px`

    if (overflowing === null) return calculated
    if (!overflowing) return 'inherit'
    if (isExpanded) return 'inherit'
    return calculated
  }, [isExpanded, overflowing, lineHeight, lines])

  return (
    <>
      <div className={styles.wrapper} ref={wrapperRef} style={{ height }}>
        {children}
        {fade && overflowing && !isExpanded && <Fader lineHeight={lineHeight} />}
      </div>
      {overflowing && (
        <ScrollLink
          to={scrollToId}
          className={styles.scrollLink}
          smooth={true}
          onClick={toggleExpanded}
          duration={200}
          offset={-10}
        >
          {isExpanded ? t('verbs.show_less') : t('verbs.read_more')}
        </ScrollLink>
      )}
    </>
  )
}

const Fader = ({ lineHeight }: { lineHeight: number }) => (
  <div
    className={styles.fade}
    style={{
      height: `${lineHeight}px`,
    }}
  />
)
